import { Component, OnInit } from '@angular/core';
import { constants } from '../constants';
import { CommonUtilitiesService } from '../common-utilities.service';
import { ActivatedRoute } from "@angular/router";
import * as $ from 'jquery';

//jquery var
declare var $: any;

@Component({
  selector: 'app-activation-menu',
  templateUrl: './activation-menu.component.html',
  styleUrls: ['./activation-menu.component.scss']
})
export class ActivationMenuComponent implements OnInit {
  public RECARGAS: string = constants.FROM_RELOAD_PAGE;
  public CARE_CHANNELS_TITLE: string = this.LANG.getLangText("CARE_CHANNELS_FOOTER_TITTLE_GENERIC");

  constructor(public LANG: CommonUtilitiesService, private route: ActivatedRoute) { }

  ngOnInit() {
    $("html, body").animate({ scrollTop: 0 }, "slow");
    //obtener params
    this.route.params.subscribe(params => this.setTabMenu(params));
  }


  /**
  * Description: Método que obtiene el id del tab y lo cambia
  * Autor: Diego Diaz
  * @param params parametros de url
  * @return N/A
 */
  setTabMenu(params) {
    let idTab = params.idTab;

    if (idTab != null) {
      if (idTab == constants.ROUTE_URL_PARAM_PORTABILITY) {
        $('#activation-portability-tab').click();
      }
      if (idTab == constants.ROUTE_URL_PARAM_DOCUMENT) {
        $('#activation-document-tab').click();
      }
      if (idTab == constants.ROUTE_URL_PARAM_PASSAPORT) {
        $('#activation-passport-tab').click();
      }
    }
  }

}
